import { Typography, Grid, Paper, Autocomplete, TextField } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { useQuery } from "@tanstack/react-query";
import { useCustomers } from "hooks";
import React, { useState } from "react";
import { StatisticsService } from "services";

export const CustomersReporting = () => {
	const [selectedCustomer, setSelectedCustomer] = useState(0);
	const { data, isFetching, error } = useQuery({ queryKey: ['customer-statistics', selectedCustomer], queryFn: async () => await StatisticsService.getCustomersStatistics(selectedCustomer) });
	const { customers } = useCustomers();

	return (
		<>
			{isFetching && <Typography variant='h3'>Loading data...</Typography>}
			{error && <Typography variant='h3'>Error has occured! Please refresh the page.</Typography>}
			<Grid container component={Paper} p={1}>
				<Grid item xs={12} pb={3}>
					{customers && customers.length > 0 && (
						<>
							<Autocomplete
								options={customers}
								getOptionLabel={option => `${option.firstName} ${option.lastName}`}
								value={customers.find(customer => customer.id === selectedCustomer) ?? null}
								onChange={(_, value) => setSelectedCustomer(value?.id || 0)}
								renderInput={params => <TextField {...params} label='Customer' size='small' />}
							/>
						</>
					)}
				</Grid>
				{data && (
					<Grid item xs={12}>
						{data.products && data.products.length > 0 && data.sales && data.sales.length > 0 && (
							<BarChart series={[{ data: data.sales }]} height={400} xAxis={[{ data: [...data.products], scaleType: 'band' }]} />
						)}
					</Grid>
				)}
			</Grid>
		</>
	);
};